import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e38a225"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "plate-vin-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-light fa-triangle-exclamation" })
], -1))
const _hoisted_3 = { class: "mx-3 title" }
const _hoisted_4 = { class: "paragraph" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "subtitle" }, " Please verify you are entering the correct trailer number or call your driver manager if you continue to have issues connecting. ", -1))
const _hoisted_7 = { class: "acknowledge-btn mx-3" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "subtitle" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "content px-3" }
const _hoisted_12 = {
  key: 1,
  class: "d-flex flex-row justify-content-around h-100"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "italic-text" }, "or", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fbx_button = _resolveComponent("fbx-button")!
  const _component_FbxInput = _resolveComponent("FbxInput")!
  const _component_FbxButton = _resolveComponent("FbxButton")!
  const _component_DriverLoaded = _resolveComponent("DriverLoaded")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, " Trailer #" + _toDisplayString(_ctx.trailer?.trailerNumber) + " is not showing in your location. ", 1),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.cannotVerify)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_fbx_button, {
                theme: "primary",
                "button-text": "Go Back",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('goBack')), ["prevent"]))
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              _createTextVNode(" Please verify you are entering the correct trailer number. Enter the "),
              _createElementVNode("span", { innerHTML: _ctx.vinOrPlateText }, null, 8, _hoisted_10),
              _createTextVNode(" to confirm you have the correct trailer. ")
            ]),
            _createElementVNode("div", _hoisted_11, [
              (_ctx.hasVin)
                ? (_openBlock(), _createBlock(_component_FbxInput, {
                    key: 0,
                    label: "Last 6 digits of the VIN *",
                    alert: _ctx.vinAlert,
                    trim: true,
                    required: true,
                    onKeyup: _withKeys(_withModifiers(_ctx.verifyTrailer, ["prevent"]), ["enter"]),
                    modelValue: _ctx.vin,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vin) = $event)),
                    limit: 6
                  }, null, 8, ["alert", "onKeyup", "modelValue"]))
                : _createCommentVNode("", true),
              (_ctx.hasVin && _ctx.hasLicensePlateNumber)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_16))
                : _createCommentVNode("", true),
              (_ctx.hasLicensePlateNumber)
                ? (_openBlock(), _createBlock(_component_FbxInput, {
                    key: 2,
                    label: "Plate Number *",
                    alert: _ctx.plateAlert,
                    trim: true,
                    required: true,
                    onKeyup: _withKeys(_withModifiers(_ctx.verifyTrailer, ["prevent"]), ["enter"]),
                    modelValue: _ctx.licensePlate,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.licensePlate) = $event))
                  }, null, 8, ["alert", "onKeyup", "modelValue"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(
                            !_ctx.hasVin || !_ctx.hasLicensePlateNumber
                                ? 'single-button-container'
                                : 'button-container'
                        )
              }, [
                _createVNode(_component_FbxButton, {
                  disabled: _ctx.isInvalidInput,
                  theme: "primary",
                  "show-loading": _ctx.isLoading,
                  "button-text": _ctx.continueButtonText,
                  onClick: _withModifiers(_ctx.verifyTrailer, ["prevent"])
                }, null, 8, ["disabled", "show-loading", "button-text", "onClick"]),
                _createVNode(_component_FbxButton, {
                  theme: "secondary",
                  "button-text": "Go Back",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('goBack')), ["prevent"]))
                })
              ], 2)
            ])
          ]))
    ]),
    (_ctx.showLoadedTrailerModal)
      ? (_openBlock(), _createBlock(_component_DriverLoaded, {
          key: 0,
          attachedTrailerNumber: _ctx.currentAttachedTrailerNumber,
          attachedTrailerCompany: _ctx.currentAttachedTrailerCompany,
          showDeepLinkButton: true,
          onOnSearchForTrailers: _ctx.hideModal,
          association: "attach"
        }, null, 8, ["attachedTrailerNumber", "attachedTrailerCompany", "onOnSearchForTrailers"]))
      : _createCommentVNode("", true)
  ]))
}